export type Role = 'ADMIN' | 'ENGINEERING';

export interface RoutePermission {
  path: string;
  roles: Role[];
}

export const routePermissions: RoutePermission[] = [
  { path: '/dashboard', roles: ['ADMIN'] },
  { path: '/documents', roles: ['ADMIN', 'ENGINEERING'] },
  { path: '/assistant', roles: ['ADMIN', 'ENGINEERING'] },
  { path: '/admin/users', roles: ['ADMIN'] },
  { path: '/admin/documents', roles: ['ADMIN'] },
];

export function canAccessRoute(role: Role, path: string): boolean {
  const permission = routePermissions.find(p =>
    path.startsWith(p.path) || p.path === path
  );

  if (!permission) return true;

  return permission.roles.includes(role);
}

export function getDefaultRoute(role: Role): string {
  switch (role) {
    case 'ADMIN':
      return '/dashboard';
    case 'ENGINEERING':
      return '/documents';
    default:
      return '/documents';
  }
}

export function isAdmin(role: Role): boolean {
  return role === 'ADMIN';
}
